const EVENTS = ['pointerdown', 'pointermove', 'touchstart', 'keydown', 'wheel', 'scroll'];

let interacted = false;
const callbacks = new Set();

const handleInteraction = () => {
    if (interacted) return;
    interacted = true;
    EVENTS.forEach((type) => window.removeEventListener(type, handleInteraction, { passive: true }));
    callbacks.forEach((callback) => callback());
    callbacks.clear();
};

if (typeof window !== 'undefined') {
    EVENTS.forEach((type) => window.addEventListener(type, handleInteraction, { passive: true }));
}

/**
 * Runs `callback` once, on the visitor's first scroll, touch, mouse move or key press.
 * Returns an unsubscribe function.
 */
export const onFirstInteraction = (callback) => {
    if (interacted) {
        callback();
        return () => {};
    }
    callbacks.add(callback);
    return () => callbacks.delete(callback);
};
